module.exports = "/legacy/2fc01d6fcb677781b1b35d279665a21a.svg";